import React, { useState, useEffect } from "react";
import axios from "axios";
import he from "he";
import "../common/Water.css";

const QuizAPI = (props) => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [incorrectAnswers, setIncorrectAnswers] = useState(0);

  useEffect(() => {
    let endpoint = "https://opentdb.com/api.php?amount=10&type=multiple";
    if (props.category) {
      endpoint += `&category=${props.category}`;
    }

    axios
      .get(endpoint)
      .then((res) => {
        console.log(res.data);
        setQuestions(res.data.results);
      })
      .catch((error) => console.error(error));
  }, [props.category]);

  const handleAnswer = (answer) => {
    if (answer === questions[currentQuestionIndex].correct_answer) {
      setScore(score + 1);
      setCorrectAnswers(correctAnswers + 1);
    } else {
      setIncorrectAnswers(incorrectAnswers + 1);
    }
    setCurrentQuestionIndex(currentQuestionIndex + 1);
  };

  const isQuizFinished = currentQuestionIndex >= questions.length;

  return (
    <>
      {questions.length > 0 ? (
        <>
          {isQuizFinished ? (
            <div>
              <h2>Quiz Results</h2>
              <p>Total Questions: {questions.length}</p>
              <p>Correct Answers: {correctAnswers}</p>
              <p>Incorrect Answers: {incorrectAnswers}</p>
              <p>Final Score: {score}</p>
              <table>
                <thead>
                  <tr>
                    <th>Question</th>
                    <th>Correct Answer</th>
                    <th>Your Answer</th>
                  </tr>
                </thead>
                <tbody>
                  {questions.map((question, index) => (
                    <tr key={question.id}>
                      <td>{he.decode(question.question)}</td>
                      <td>{question.correct_answer}</td>
                      <td>{question.correct_answer === question.user_answer ? "Correct" : question.user_answer}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <>
              <h2>Question {currentQuestionIndex + 1} of {questions.length}</h2>
              <table className="center">
                <thead>
                  <tr>
                    <th>Question</th>
                    <th>Option 1</th>
                    <th>Option 2</th>
                    <th>Option 3</th>
                    <th>Option 4</th>
                  </tr>
                </thead>
                <tbody>
                  <tr key={questions[currentQuestionIndex].id}>
                    <td>{he.decode(questions[currentQuestionIndex].question)}</td>
                    {[
                      ...questions[currentQuestionIndex].incorrect_answers,
                      questions[currentQuestionIndex].correct_answer,
                    ]
                      .sort()
                      .map((option) => (
                        <td key={option}>
                          <button onClick={() => handleAnswer(option)}>
                            {option}
                          </button>
                        </td>
                      ))}
                  </tr>
                </tbody>
              </table>
            </>
          )}
        </>
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
};

export default QuizAPI;
